import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Loader } from "@/components/kv";
import { ConsentModal } from "@/components/ConsentModal";
import Login from "@/pages/Login";
import StaffApp from "@/pages/staff/StaffApp";
import AdminApp from "@/pages/admin/AdminApp";

const home = (u) => (u.role === "admin" ? "/admin" : "/staff");

const Guard = ({ role, children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to={home(user)} replace />;
  return (
    <>
      {children}
      {!user.kvkk_accepted_at && <ConsentModal />}
    </>
  );
};

const LoginRoute = () => {
  const { user, ready } = useAuth();
  if (!ready) return <Loader />;
  return user ? <Navigate to={home(user)} replace /> : <Login />;
};

const Fallback = () => {
  const { user, ready } = useAuth();
  if (!ready) return <Loader />;
  return <Navigate to={user ? home(user) : "/login"} replace />;
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/staff/*" element={<Guard role="staff"><StaffApp /></Guard>} />
            <Route path="/admin/*" element={<Guard role="admin"><AdminApp /></Guard>} />
            <Route path="*" element={<Fallback />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
